import * as actions from './actions'
import { saveEntities } from '../factories'
import { sequences as route } from '../route'
import { showFeedback } from '../feedback/factories'
import { set } from 'cerebral/factories'
import { props } from 'cerebral'
import { loadProfilesSequence } from '../profiles/factories'
import { compose, flatten, map, path, pluck } from 'ramda'

const loadProfiles = loadProfilesSequence(compose(pluck('profile'), path(['props', 'entities', 'carpools'])), 'profileIds')
const loadPartyProfiles = loadProfilesSequence(compose(flatten, map(({ profile, party = [] }) => [profile].concat(pluck('profile', party))), path(['props', 'entities', 'carpools'])), 'profileIds')

export const find = [
  //
  actions.find,
  saveEntities(),
  loadProfiles,
  loadPartyProfiles,
]

export const findForList = [
  //
  set(props`useRouteParams`, true),
  actions.find,
  actions.setList,
  saveEntities(),
  loadProfiles,
  loadPartyProfiles,
]

export const get = [
  //
  actions.get,
  saveEntities(),
  loadProfiles,
  loadPartyProfiles,
]

export const save = [
  //
  actions.save,
  actions.clearList,
  saveEntities(),
  showFeedback({ title: 'Carpool saved', type: 'success' }),
  route.toCarpools,
]

export const remove = [
  //
  actions.remove,
  showFeedback({ title: 'Carpool deleted', type: 'success' }),
  findForList,
]

export const updateEntities = [
  //
  saveEntities(),
]

export const updateList = [
  //
  actions.setList,
]
